import {
  useMutation,
  useSuspenseQuery,
} from "@tanstack/react-query";
import {
  createFileRoute,
  useNavigate,
} from "@tanstack/react-router";

import { useTRPC } from "@/infrastructure/trpc/react";
import { AgentEditor } from "@/speech-agent/components/agent-editor";

export const Route = createFileRoute(
  "/app/speech-agent/agents/$slug"
)({
  loader: ({ context, params }) => {
    void context.queryClient.prefetchQuery(
      context.trpc.speechAgent.agents.get.queryOptions({
        slug: params.slug,
      })
    );
  },
  component: EditAgentPage,
});

function EditAgentPage() {
  const { slug } = Route.useParams();
  const trpc = useTRPC();
  const navigate = useNavigate();

  const { data: agent } = useSuspenseQuery(
    trpc.speechAgent.agents.get.queryOptions({ slug })
  );

  const updateAgent = useMutation(
    trpc.speechAgent.agents.update.mutationOptions({
      onSuccess: () => {
        void navigate({ to: "/app/speech-agent/agents" });
      },
    })
  );

  const deleteAgent = useMutation(
    trpc.speechAgent.agents.delete.mutationOptions({
      onSuccess: () => {
        void navigate({ to: "/app/speech-agent/agents" });
      },
    })
  );

  return (
    <AgentEditor
      title={`Upravit: ${agent.name}`}
      initialMd={agent.rawMd}
      isSaving={updateAgent.isPending}
      onSave={(rawMd) => {
        updateAgent.mutate({ slug, rawMd });
      }}
      onDelete={() => {
        deleteAgent.mutate({ slug });
      }}
      onCancel={() => {
        void navigate({ to: "/app/speech-agent/agents" });
      }}
      errorMessage={
        updateAgent.error?.message ??
        deleteAgent.error?.message
      }
    />
  );
}
